import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ModalGeneralComponent } from '../modal-general/modal-general.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-desplegables-facultdad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './desplegables-facultdad.component.html',
  styleUrl: './desplegables-facultdad.component.scss'
})
export class DesplegablesFacultdadComponent implements OnInit, AfterViewInit {
  @Input() language = 'es';
  @Input() info: any;
  html = '<p>-</p>';
  @Input() docentes: any = []
    ;
  expandedHtml = '';
  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  lastMouseX = 0;
  lastMouseY = 0;
  isModalOpen = false;
  isDesktop: boolean;
  htmlsanitizado: any;
  selectedItemIndex: number | null = null;
  selectedItemPlan: any = null;
  titlehtml: any;
  showExpandButton = false;
  expanded = false;
  contentMaxHeight: number | null = null;
  private readonly collapsedContentHeight = 400;
  @ViewChildren('contentWrapper') contentWrappers!: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren('itemHeader') itemHeaders!: QueryList<ElementRef<HTMLElement>>;
  constructor(private renderer: Renderer2, public dialog: MatDialog, private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.isDesktop = window.innerWidth > 767;
    this.getPlanData();
  }

  ngAfterViewInit(): void {
    // El primer item se selecciona antes de que exista el content-wrapper.
    setTimeout(() => this.checkShowMore(), 0);
  }
  async getPlanData() {
    this.info.accordion.items = this.info?.accordion?.items.filter(d => d.title && d.body);
    this.onSelectItem(0);
  }

  toggleExpand() {
    const wasExpanded = this.expanded;
  
    if (wasExpanded && !this.isDesktop && this.selectedItemIndex !== null) {
      this.scrollToSelectedItem();
      setTimeout(() => {
        this.expanded = false;
        this.contentMaxHeight = this.collapsedContentHeight;
      }, 50);
      return;
    }

    this.expanded = !this.expanded;

    if (!this.isDesktop) {
      if (this.expanded) {
        setTimeout(() => this.setExpandedContentHeight(), 0);
      } else {
        this.contentMaxHeight = this.collapsedContentHeight;
      }
    }

  }

  private scrollToSelectedItem(): void {
    const item = this.itemHeaders?.toArray()[this.selectedItemIndex as number]?.nativeElement;
    if (!item || this.isDesktop) return;

    item.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktop = window.innerWidth > 767;
    if (this.isDesktop) {
      this.contentMaxHeight = null;
    } else if (!this.expanded) {
      this.contentMaxHeight = this.collapsedContentHeight;
    }
    this.checkShowMore();
  }
  onSelectItem(index: number) {
    this.htmlsanitizado = null;
    this.isDesktop = window.innerWidth > 767;
    if (!this.isDesktop && this.selectedItemIndex === index) {
      this.selectedItemIndex = null;
      this.selectedItemPlan = null;
      this.htmlsanitizado = '';
      this.titlehtml = '';
      this.expanded = false;
      this.showExpandButton = false;
      this.contentMaxHeight = this.collapsedContentHeight;
      return;
    }

    this.selectedItemIndex = index;
    this.selectedItemPlan = this.info?.accordion?.items[index];
    this.expanded = false;
    this.showExpandButton = false;
    this.contentMaxHeight = this.isDesktop ? null : this.collapsedContentHeight;
    this.titlehtml = this.selectedItemPlan.title;
    if (this.selectedItemPlan.hiddenTitle) this.titlehtml = "";


    if (this.selectedItemPlan.popup == true) {
      this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: this.selectedItemPlan.body, title: this.selectedItemPlan.title, tipografy: "nunito-medium", tipografyTitle: "nunito-bold" } });
      this.htmlsanitizado = "";
      this.titlehtml = "";
      this.checkShowMore();
    } else {
      const body = this.selectedItemPlan.body.replace(
        /<(h[1-5]|span)([^>]*)>/g,
        `<$1$2 style="color: ${this.info?.venue?.color}">`
      );
      const bodyWithDivider = this.isDesktop
        ? `${body}<hr style="margin:20px 0px 5px 0px!important;">`
        : body;
      this.htmlsanitizado = this.domSanitizer.bypassSecurityTrustHtml(bodyWithDivider);
        this.checkShowMore()
    }

  }


  checkShowMore() {
    if (!this.selectedItemPlan || !this.contentWrappers) return;

    this.isDesktop = window.innerWidth > 767;
    setTimeout(() => {
      const wrapper = this.getVisibleContentWrapper();
      if (!wrapper) return;

      const inner = wrapper.querySelector<HTMLElement>('.bodyplan');
      if (!inner) return;

      const innerHeight = inner.scrollHeight;
      if (!innerHeight) {
        if (!this.isDesktop) this.contentMaxHeight = this.collapsedContentHeight;
        if (inner.innerHTML.trim()) setTimeout(() => this.checkShowMore(), 50);
        return;
      }
      if (this.isDesktop) {
        const maxHeightPx = window.innerWidth * 0.35;
        this.showExpandButton = innerHeight > maxHeightPx;
      } else {
        this.showExpandButton = innerHeight > this.collapsedContentHeight;
      }


      if (!this.showExpandButton) {
        this.expanded = true;
        this.setExpandedContentHeight(wrapper);
      } else if (this.expanded && !this.isDesktop) {
        this.setExpandedContentHeight(wrapper);
      } else if (!this.isDesktop) {
        this.contentMaxHeight = this.collapsedContentHeight;
      }
    }, 50);
  }

  private getVisibleContentWrapper(): HTMLElement | null {
    const wrappers = this.contentWrappers.toArray();
    const visibleContainer = this.isDesktop ? '.desk' : '.mob';

    return wrappers.find(wrapper => {
      const container = wrapper.nativeElement.closest(visibleContainer);
      return container && getComputedStyle(container).display !== 'none';
    })?.nativeElement
      || wrappers[0]?.nativeElement
      || null;
  }

  private setExpandedContentHeight(wrapper?: HTMLElement): void {
    const visibleWrapper = wrapper || this.getVisibleContentWrapper();
    const inner = visibleWrapper?.querySelector<HTMLElement>('.bodyplan');

    if (inner) {
      if (inner.scrollHeight > 0) {
        this.contentMaxHeight = inner.scrollHeight;
      } else if (!this.isDesktop) {
        this.contentMaxHeight = this.collapsedContentHeight;
        if (inner.innerHTML.trim()) setTimeout(() => this.setExpandedContentHeight(visibleWrapper), 50);
      }
    }
  }

  transformarYoutubeLinks(html: string): string {
    // Reemplaza todos los iframe con youtube.be a youtube.com/embed
    return html.replace(/src="https:\/\/youtu\.be\/([a-zA-Z0-9_-]+)(\?[^"]*)?"/g, (match, videoId, params) => {
      const embedUrl = `https://www.youtube.com/embed/${videoId}${params || ''}`;
      return `src="${embedUrl}"`;
    });
  }

  flechaAbajoImg = '';
  flechaArribaImg = '';


  async armarFlechas() {
    const downSvg = await (await fetch('./assets/svg/flecha-abajo.svg')).text();
    const upSvg = await (await fetch('./assets/svg/flecha-arriba.svg')).text();

    const downColored = this.changeSvgColor(downSvg, this.info?.venue?.color);
    const upColored = this.changeSvgColor(upSvg, this.info?.venue?.color);

    this.flechaAbajoImg = await this.svgToPngUrl(downColored, 30);
    this.flechaArribaImg = await this.svgToPngUrl(upColored, 30);
  }


  async generarRedes(d: any) {
    const redes = [
      { campo: "instagram", icono: "./assets/svg/instagram.svg" },
      { campo: "linkedin", icono: "./assets/svg/linkedin.svg" },
      { campo: "facebook", icono: "./assets/svg/facebook.svg" },
      { campo: "twitter", icono: "./assets/svg/twitter.svg" },
      { campo: "youtube", icono: "./assets/svg/youtube.svg" }
    ];

    const svgPromises = redes
      .filter(red => d[red.campo] && d[red.campo]?.trim() !== "")
      .map(async red => {

        let svgText = await (await fetch(red.icono)).text();
        svgText = this.changeSvgColor(svgText, this.info?.venue?.color);


        const pngUrl = await this.svgToPngUrl(svgText, 40);

        return `
        <a href="${d[red.campo]}" target="_blank" class="red-link">
          <img src="${pngUrl}" class="icon-red">
        </a>
      `;
      });

    return (await Promise.all(svgPromises)).join('');
  }


  changeSvgColor(svg: string, color: string): string {
    svg = svg.replace(/fill\s*=\s*["']#[0-9a-fA-F]{3,6}["']/g, `fill="${color}"`);
    svg = svg.replace(/fill:\s*#[0-9a-fA-F]{3,6}/g, `fill:${color}`);

    return svg;
  }
  svgToPngUrl(svg: string, size = 30): Promise<string> {
    return new Promise(resolve => {
      const img = new Image();
      const svgBlob = new Blob([svg], { type: "image/svg+xml" });
      const url = URL.createObjectURL(svgBlob);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext("2d")!;
        ctx.drawImage(img, 0, 0, size, size);

        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png")); // 👉 devuelve la image generada
      };

      img.src = url;
    });
  }
  toggleDocente(i) {
    const cuerpo = document.getElementById("cuerpo-" + i);
    const flechaDown = document.getElementById("flecha-down-" + i);
    const flechaUp = document.getElementById("flecha-up-" + i);
    const estabaOculto = cuerpo.classList.contains("oculto");

    if (estabaOculto) {
      cuerpo.classList.remove("oculto");
      cuerpo.classList.add("open");
      flechaDown.classList.add("oculto");
      flechaUp.classList.remove("oculto");
    } else {
      cuerpo.classList.add("oculto");
      cuerpo.classList.remove("open");
      flechaUp.classList.add("oculto");
      flechaDown.classList.remove("oculto");
    }
    setTimeout(() => {
      this.checkShowMore();
    }, 50);
  }


   url(link: any): string {

    if (!link) return '';

    if (this.isExternalUrl(link)) {
      return link;
    }

    if (link.startsWith('/')) {
      link = link.substring(1);
    }

    return `/${this.language}/${link}`;
  }

  isExternalUrl(urlStr: string): boolean {
    return urlStr.startsWith('http://') || urlStr.startsWith('https://');
  }
}
